module.exports = __webpack_public_path__ + "static/survey-cta@2x-5730e97fa73f944e0b1122ef415f1970.png";